import { render } from "./SelectedFiles.vue?vue&type=template&id=1b0ab2ec&scoped=true"
import script from "./SelectedFiles.vue?vue&type=script&lang=js"
export * from "./SelectedFiles.vue?vue&type=script&lang=js"

import "./SelectedFiles.vue?vue&type=style&index=0&id=1b0ab2ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0ab2ec"]])

export default __exports__